export default __webpack_public_path__ + "static/media/c002-PPII-15.8de836d0.svg";